export const accountSpecialLuggage = {
  OPEN: 'accountSpecialLuggage.loaded',
  SUBMITTED: 'accountSpecialLuggage.submitted',
  ERROR_SUBMITTING: 'accountSpecialLuggage.errorSubmitting'
}
